<template>
    <div class="current-conversation-wrapper">
        <div
            v-if="showCurrentConversation"
            class="current-conversation"
            @scroll="onScroll"
        >
            <div class="header">
                <div class="header-name flex fs">
                    <img
                        class="item-avatar-img shape-circle"
                        :src="currentConversation.userProfile.avatar  ||defImage('actor')"
                    >
                    <div class="name">{{ name }}</div>
                </div>
                <div class="close" v-if="isClose == 'true'">
                    <span
                        class="el-icon-close"
                        @click="handleClose"
                    />
                </div>
            </div>
            <div class="content">
                <div
                    ref="message-list"
                    class="message-list"
                    @scroll="onScroll"
                >
                    <div
                        v-if="!isCompleted"
                        class="more"
                    >
                        <el-button
                            type="text"
                            style="color: #409EFF !important"
                            @click="handleMore"
                        >{{$t('查看更多')}}</el-button>
                    </div>
                    <div
                        v-else
                        class="no-more"
                    >{{$t('没有更多了')}}</div>
                    <!-- 每条消息 -->
                    <v-message-item
                        v-for="message in currentMessageList"
                        :key="message.ID"
                        :message="message"
                    />
                    
                </div>
                <div
                    v-show="isShowScrollButtomTips"
                    class="newMessageTips"
                    @click="scrollMessageListToButtom"
                >{{$t('回到最新位置')}}</div>
            </div>
            <div
                v-if="showMessageSendBox"
                class="footer"
            >
                <v-message-send-box />
            </div>
        </div>
        <div class="current-conversation l-h-650" v-else>
            <div class="text-center">{{ $t('common.noData') }}</div>
        </div>
        <div>
            <!-- relay 转发？ merge 合并 -->
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import MessageSendBox from './MessageSendBox.vue'
import MessageItem from './MessageItem.vue'

export default {
    name: 'CurrentConversation',
    components: {
        'v-message-send-box': MessageSendBox,
        'v-message-item': MessageItem
    },
    props: {
        isClose: {
            type: [String, Boolean],
            default: () => 'true'
        },
    },
    data() {
        return {
            isShowScrollButtomTips: false,
            preScrollHeight: 0,
            showConversationProfile: false,
            timeout: '',
            checkList: [],
            selectedMessageList: [],
            mergerMessage: null,
            positionX: 0,
            positionY: 0
        }
    },
    computed: {
        ...mapState({
            // currentConversation: state => state.timStore.currentConversation,
            // currentUnreadCount: state => state.timStore.currentConversation.unreadCount,
            // currentMessageList: state => state.timStore.currentMessageList,
            // isCompleted: state => state.timStore.isCompleted,
            // mergerMessageList: state => state.timStore.mergerMessageList,
            // isShowConversationList: state => state.timStore.isShowConversationList,
            // chatDialogVisible: state => state.timStore.chatDialogVisible,
            // userInfo: state => state.timStore.userInfo
        }),
        ...mapGetters([ 'toAccount', 'hidden',
            'currentConversation',
            'currentMessageList',
            'isCompleted',
            'mergerMessageList',
            'isShowConversationList',
            'chatDialogVisible',
            'userInfo',
            'currentConversationInfo'
        ]),
        // 是否显示当前会话组件
        showCurrentConversation() {
            return !!this.currentConversation.conversationID
        },
        name() {
            if (this.currentConversation.type === 'C2C') {
                console.log('this.currentConversation--->', this.currentConversation)
                // return this.currentConversation.userProfile.nick
                return this.currentConversation.remark || this.currentConversation.userProfile.nick || this.currentConversation.userProfile.userID
            } else if (this.currentConversation.type === 'GROUP') {
                return this.currentConversation.groupProfile.name || this.toAccount
            } else if (this.currentConversation.conversationID === '@TIM#SYSTEM') {
                return this.$t('系统通知')
            }
            return this.toAccount
        },
        showMessageSendBox() {
            return this.currentConversation.type !== this.$TIM_TYPES.CONV_SYSTEM
        }
    },
    watch: {
        currentUnreadCount(next) {
            if (!this.hidden && next > 0) {
                this.$TIM.setMessageRead({ conversationID: this.currentConversation.conversationID })
            }
        },
        hidden(next) {
            if (!next && this.currentUnreadCount > 0) {
                this.$TIM.setMessageRead({ conversationID: this.currentConversation.conversationID })
            }
        }
        // currentUnreadCount(next) {
        //     if (this.chatDialogVisible && next > 0) {
        //         this.$TIM.setMessageRead({ conversationID: this.currentConversation.conversationID })
        //     }
        // },
        // chatDialogVisible(newVal) {
        //     if (newVal && this.currentUnreadCount > 0) {
        //         this.$TIM.setMessageRead({ conversationID: this.currentConversation.conversationID })
        //     }
        // }
    },

    mounted() {
        this.$bus.$on('image-loaded', this.onImageLoaded)
        this.$bus.$on('scroll-bottom', this.scrollMessageListToButtom)
        this.$bus.$on('mergerSelected', this.mergerSelectedHandler)

        console.log(this.currentConversationInfo)
        this.onImageLoaded()
        this.scrollMessageListToButtom()
        this.mergerSelectedHandler()

        if (this.currentConversation.conversationID === '@TIM#SYSTEM') {
            return false
        }
    },
    updated() {
        this.keepMessageListOnButtom()
        // 1. 系统会话隐藏右侧资料组件
        // 2. 没有当前会话时，隐藏右侧资料组件。
        //    背景：退出群组/删除会话时，会出现一处空白区域
        if (this.currentConversation.conversationID === '@TIM#SYSTEM' || typeof this.currentConversation.conversationID === 'undefined') {
            this.showConversationProfile = false
        }
    },
    methods: {
        handleMore() {
            this.$store.dispatch('getMessageList', this.currentConversation.conversationID)
        },
        closeSelectMessage() {
            this.$store.commit('resetSelectedMessage', false)
        },
        mergerSelectedHandler() {
            this.selectedMessageList = []
            this.checkList = []
            this.$store.commit('setSelectedMessage', true)
        },
        mergerRelay() {
            this.selectedMessage()
            this.$store.commit('setRelayType', 3)
        },
        singleRelay() {
            this.selectedMessage()
            this.$store.commit('setRelayType', 2)
        },
        selectedMessage() {
            let messageList = []
            this.selectedMessageList = []
            this.checkList.forEach((id) => {
                messageList = this.currentMessageList.find((item) => {
                    return item.ID === id
                })
                this.selectedMessageList.push(messageList)
            })

            this.$store.commit('showConversationList', true)
            // this.closeSelectMessage() // TODO
            this.$store.commit('setSelectedMessageList', this.selectedMessageList)
        },
        onScroll({ target: { scrollTop }}) {
            const messageListNode = this.$refs['message-list']
            if (!messageListNode) {
                return
            }
            if (this.preScrollHeight - messageListNode.clientHeight - scrollTop < 20) {
                this.isShowScrollButtomTips = false
            }
        },
        // 如果滚到底部就保持在底部，否则提示是否要滚到底部
        keepMessageListOnButtom() {
            const messageListNode = this.$refs['message-list']
            if (!messageListNode) {
                return
            }
            // 距离底部20px内强制滚到底部,否则提示有新消息
            if (this.preScrollHeight - messageListNode.clientHeight - messageListNode.scrollTop < 20) {
                this.$nextTick(() => {
                    messageListNode.scrollTop = messageListNode.scrollHeight
                })
                this.isShowScrollButtomTips = false
            } else {
                this.isShowScrollButtomTips = true
            }
            this.preScrollHeight = messageListNode.scrollHeight
        },
        // 直接滚到底部
        scrollMessageListToButtom() {
            this.$nextTick(() => {
                const messageListNode = this.$refs['message-list']
                if (!messageListNode) {
                    return
                }
                messageListNode.scrollTop = messageListNode.scrollHeight
                this.preScrollHeight = messageListNode.scrollHeight
                this.isShowScrollButtomTips = false
            })
        },
        onImageLoaded() {
            this.keepMessageListOnButtom()
        },
        handleClose() {
            this.$store.commit('toogleChatDialog')
        }
    }
}
</script>

<style lang="stylus" scoped>
/* 当前会话的骨架屏 */
.current-conversation-wrapper{
    height: 500px;
    /* background-color: #f5f5f5; */
    color: #1c2438;
    display: flex;
    background: #ffffff;
    .current-conversation {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 599px;
    }
    .profile {
        height:80vh;
        overflow-y: scroll;
        width: 220px;
        border-left: 1px solid #e7e7e7;
        flex-shrink: 0;
    }
    .more {
        display: flex;
        justify-content: center;
        font-size: 12px;
    }
    .no-more {
        display: flex;
        justify-content: center;
        color: #a5b5c1;
        font-size: 12px;
        padding: 10px 10px;
    }
}

.header {
    border-bottom: 1px solid #e7e7e7;
    position: relative;
    display: flex;
    justify-content: space-between;
    padding:10px;
    .name {
        padding: 0 20px;
        color: #1c2438;
        font-size: 18px;
        line-height: 30px;
        text-shadow: #76828c 0 0 0.1em;
    }
    .item-avatar-img{
        height:32px;
        width: 32px;
        border-radius: 5px;
        border: 1px solid #e7e7e7;
    }
    .close {
        font-size: 20px;
        .el-icon-close {
            transition: transform .3s ease;
            cursor: pointer;
            &:hover {
                color: $color-main;
                transform: rotate(180deg);
            }
        }
    }
    .btn-more-info {
        position: absolute;
        top: 10px;
        right: -15px;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        cursor: pointer;
        &::before {
            position: absolute;
            right: 0;
            z-index: 0;
            content: "";
            width: 15px;
            height: 30px;
            border: 1px solid #e7e7e7;
            border-radius: 0 100% 100% 0/50%;
            border-left: none;
            background-color: #f5f5f5;
        }
        &::after {
            content: "";
            width: 8px;
            height: 8px;
            transition: transform 0.8s;
            border-top: 2px solid #a5b5c1;
            border-right: 2px solid #a5b5c1;
            float:right;
            position:relative;
            top: 11px;
            right: 8px;
            transform:rotate(45deg);
        }
        &.left-arrow {
            transform: rotate(180deg);
            &::before {
                background-color: #ffffff;
            }
        }
        &:hover {
            &::after {
                border-color: #5cadff;
            }
        }
    }
}
.content {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    position: relative;
    .message-list {
        width: 100%;
        box-sizing: border-box;
        overflow-y: auto;
        padding: 0 20px;
    }
    .newMessageTips {
        position: absolute;
        cursor: pointer;
        padding: 5px;
        width: 120px;
        margin: auto;
        left: 0;
        right: 0;
        bottom: 5px;
        font-size: 12px;
        text-align: center;
        border-radius: 10px;
        border: #e9eaec 1px solid;
        background-color: #ffffff;
        color: #2d8cf0;
    }
}
.footer {
    border-top: 1px solid #e7e7e7;
    .merger-btn {
        height: 150px;
        padding: 3px 20px 20px 20px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        padding-top: 50px;
        .relay-btn {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 60px;
            height: 50px;
            .relay-icon {
                display: block;
                border-radius: 50%;
                width: 30px;
                height: 30px;
                background-color: #ffffff;
                margin-bottom: 5px;
            }
            .relay-title {
                display: block;
                font-size: 13px;
            }
        }
    }
}

.show-more {
    text-align: right;
    padding: 10px 20px 0 0;
}
.l-h-650{
    line-height:599px
}
</style>
